const Games = () => {
    return <h1>Games Page</h1>;
};

export default Games;
